export const MESSAGES_COUNT = 30;
export const MAX_MESSAGE_LENGTH = 140;
